export default __webpack_public_path__ + "static/media/regulatory--maximum-speed-limit-led-60--g2.aed4f160.png";